import React, { useEffect, useRef, useState } from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import ApiHelper from '../../helperFunction/ApiHelper';
import API_ENDPOINTS from '../../helperFunction/Constant';
import { Link, useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';

const ForgotPassword = () => {

    const toast = useRef(null)

    const schema = yup.object({
        email: yup.string().required("Email is required").email("Enter a valid email address"),
    });

    const { register, handleSubmit, resetField, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const onSubmit = (data) => {
        ApiHelper.post(API_ENDPOINTS.FORGOT_PASSWORD, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                resetField('email')
            }
        }).catch((errors) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: errors.response.data.message, life: 3000 })
        })
    };

    return (
        <>
            <Toast ref={toast} />
            <div class="container-xxl">
                <div class="authentication-wrapper authentication-basic container-p-y">
                    <div class="authentication-inner">
                        <div class="card">
                            <div class="card-body">
                                <div class="app-brand justify-content-center">
                                    <Link to="/" class="app-brand-link gap-2">
                                        <span class="app-brand-logo demo">
                                            <img src="/img/logo-light.png" width="200px" />
                                        </span>
                                    </Link>
                                </div>
                                <h4 class="mb-2">Welcome to Tajurba Learning! 👋</h4>
                                <p class="mb-4">Please Enter Email to Send reset-password link</p>
                                <form className="mb-3" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label"> Email address </label>
                                        <input type="email" className="form-control" id="email" placeholder="Enter your email address" {...register("email")} />
                                        {errors.email && (<small className="text-danger"> {errors.email.message} </small>)}
                                    </div>
                                    <button className="btn btn-primary d-grid w-100" type="submit" > Send </button>
                                    <div class="text-center mt-3">
                                        <Link to="/login" class="d-flex align-items-center justify-content-center">
                                            <i class="bx bx-chevron-left scaleX-n1-rtl bx-sm"></i>
                                            Back to login
                                        </Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ForgotPassword
